<!-- 充值明细 -->
<template>
<div class='recharge'>
  <Head :goBack='true' show="" :backPath="'/mall/phone/recharge'" :title="type==1?'充值记录':'交易明细'"></Head>
  <div class="recharge_kong">&nbsp;</div>
  <div class="current-date"><span @click="dateBtn">{{currentDate|dateNumber}}&nbsp;&nbsp;<van-icon name="arrow-down" class="current-date-ico" /></span></div>
  <van-action-sheet v-model="show">
    <div class="content">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :formatter="formatter"
        @cancel="cancel"
        @confirm="confirm"
      />
    </div>
  </van-action-sheet>
  <template v-if="PayRecord.length || Record.length">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="我也是有底线的---"
      :immediate-check="false"
      :offset="100"
      @load="onLoad"
    > 
      <ul class="recharge_log" v-if="type==1">
          <li class="recharge_log_li" v-for="(item,i) of Record" :key="i">
              <div class="cl">
                  <span class="recharge_log-title">{{item.storeName}}</span>
                  <span class="recharge_log-good">{{item.title+'：'+'充'+item.rechargeMoney+'送'+ item.giveMoney+'等于'+item.rechargeMoney*1+item.giveMoney*1+'元'}}</span>
                  <span class="recharge_log-price">+{{item.rechargeMoney*1+item.giveMoney*1}}</span>
              </div>
              <div>
                <span class="recharge_detail-time">{{item.createTime|datetime}}</span>
              </div>
          </li>
      </ul>
      <ul class="recharge_detail" v-if="type==2">
        <li class="recharge_detail_li" v-for="(item,i) of PayRecord" :key="i">
          <img :src="item.mainImage" alt="" class="recharge_detail_img">
          <div class="recharge_detail_li_left">
            <div class="cl">
                <span class="recharge_detail-title">{{item.storeName}}</span>
                <span class="recharge_detail-good">{{item.title}}</span>
                <span class="recharge_detail-price" :style="{color:item.type==1?'':'red'}">{{item.type==1?"-":"+"}}{{item.money}}</span>
            </div>
            <div>
              <span class="recharge_detail-time">{{item.createTime|datetime}}</span>
            </div>
          </div>
        </li>
      </ul>
    </van-list>
    <vueToTop :size='30' :type='8' :top='50' color='#13A556' :bottom='40'></vueToTop>
  </template>
  <!-- //没数据时显示 -->
  <div class="no-data" v-if="!PayRecord.length && !Record.length">
    暂无记录...
  </div>
</div>
</template>

<script>

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  show:false,
  type:1,
  currentDate: new Date(),
  PayRecord:[],
  Record:[],
  rechargeDetailList:[
    {
      storeName: '线上消费',
      createTime: '2020-11-26',
      title:"1",
      rechargeMoney:"1",
      giveMoney:"1",
    },
  ],
  selectedPrice: {},
  //是否处于加载状态
  loading: false,
  //是否加载完毕
  finished: false,
  pageNo: 1,
  pageSize: 20
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  init() {
    this.pageNo = 1;
    this.finished = false;
    this.loading = true;
    this.PayRecord = [];
    this.Record = [];
  },
  dateBtn(){
     this.show=true
  },
  formatter(type, val) {
    if (type === 'year') {
      return `${val}年`;
    } else if (type === 'month') {
      return `${val}月`;
    }
    return val;
  },
  cancel(){
    console.log("取消")
    this.show=false
  },
  confirm(){
    this.init();
    if(this.type==1){
      this.rechargeRecord()
    }else{
      this.rechargePayRecord()
    }
    this.show=false
  },
  rechargeRecord(){
    let data= {
      pageStart: this.pageNo,
      pageSize: this.pageSize,
      year:this.currentDate.getFullYear(),
      month :this.currentDate.getMonth() + 1
    }
    this.$api.recharge.rechargeRecord(data).then((res)=>{
      if(res.code=='200'){
        this.Record = this.Record.concat(res.result);
        // 加载状态结束
        this.loading = false;
        if (res.result.length < this.pageSize) {
          this.finished = true;
        }
       }else{
         Toast(res.msg)
       }
    }).catch((err) =>{ 
        console.log(err.data)
    })
  },
  rechargePayRecord(){
    let data= {
      pageStart:this.pageNo,
      pageSize: this.pageSize,
      year:this.currentDate.getFullYear(),
      month :this.currentDate.getMonth() + 1
    }
    this.$api.recharge.rechargePayRecord(data).then((res)=>{
      if(res.code==200){
        this.PayRecord = this.PayRecord.concat(res.result);
        // 加载状态结束
        this.loading = false;
        if (res.result.length < this.pageSize) {
          this.finished = true;
        }
      }else{
        Toast(res.msg)
      }
    }).catch((err) =>{ 
        console.log(err.data)
    })
  },
  onLoad() {
    this.pageNo++;
    if(this.type==1){
      this.rechargeRecord()
    }else{
      this.rechargePayRecord()
    }
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  let type = this.$route.query.type*1;
    if (type) {
      this.type= type
      if(this.type==1){
        this.rechargeRecord()
      }else{
        this.rechargePayRecord()
      }
    }else{
       this.$router.push({
        name: 'recharge'
      })
    }
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.recharge_kong{
  width: 100%;
  height: 100px;
}
.loding{
  width: 100%;
  height: 100vh;
}
.recharge{
  background-color: #fff;
  .current-date{
    background-color: #f7f8fa;
    padding: 0 30px;
    line-height: 112px;
    font-size: 32px;
  }
  .current-date-ico{
    position: relative;
    top: 6px;
    
  }
  .content{
     padding: 0px 16px 80px;
     .van-picker__cancel, .van-picker__confirm{
       
     }
  }

  .recharge_header{
    width: 100%;
    height: 350px;
    padding: 20px 35px;
    box-sizing: border-box;
    background: url('~@/assets/images/recharge.png') no-repeat center center;
    background-size: 100% 100%;
    color: #fff;
    .recharge_balance{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .recharge_balance_price{
        font-size: 50px;
        font-weight: bold;
      }
      .recharge_balance_now{
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    
  }
  .recharge_log{
    padding: 20px 30px;
    .recharge_log_li{
      padding: 10px 0;
      border-bottom: 1px solid #ebedf0;
    }
    .recharge_log-title{
      float: left;
      font-size: 28px;
      line-height: 50px;
      color: #0c0c0c;
    }
    .recharge_log-good{
      color: #a5a5a5;
      float: left;
      line-height: 50px;
      font-size: 26px;
    }
    .recharge_log-price{
      float: right;
      color: #151515;
      font-size: 28px;
      line-height: 50px;
      font-weight:bold;
    }
    .recharge_log-time{
      color: #a5a5a5;
      font-size: 26px;
      line-height: 50px;
    }
  }
  .recharge_detail{
    min-height: 80vh;
    padding: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    .recharge_detail_li{
      width: 100%;
      padding-left:30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .recharge_detail_img{
        margin: 17px 30px 17px 3px;
        width: 90px;
        height: 90px;
        border-radius:100%;
      }
      .recharge_detail_li_left{
        width: 590px;
        height: 127px;
        border-bottom: 1px solid #ebedf0;
        .recharge_detail-title{
          float: left;
          font-size: 28px;
          color: #0c0c0c;
          padding-top: 24px;
          overflow:hidden;
          max-width: calc(100% - 300px);
          text-overflow:ellipsis;
          display:-webkit-box;    //将对象作为弹性伸缩盒子模型显示。
          -webkit-box-orient:vertical;  // 从上到下垂直排列子元素
          -webkit-line-clamp:2; //显示的行数
        }
        .recharge_detail-good{
          color: #a5a5a5;
          float: left;
          font-size: 26px;
          padding-top: 24px;
        }
        .recharge_detail-price{
          float: right;
          color: #151515;
          font-size: 28px;
          font-weight:bold;
          padding-top: 24px;
          padding-right: 44px;
        }
        .recharge_detail-time{
          color: #a5a5a5;
          font-size: 26px;
          display: inline-block;
          padding-top: 16px;
        }
      }
      .recharge_detail_li_right{
        color:#f68080;
        font-size: 28px;
      }
      .recharge_detail_li_right_price{
        color:#8bdeb4;
      }
    }
    .recharge_detail_li:last-child{
      .recharge_detail_li_left{
        border: 0;
      }
    }
  }
  .recharge_null{
    background-color: #f9f9f9;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    p{
      margin-top: 60px;
      font-size: 34px;
      color:#606060;
    }
  }
}
.no-data{
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
}
</style>